module.exports = __webpack_public_path__ + "static/media/save.dc7211fb.svg";